module.exports = __webpack_public_path__ + "img/d_4.c19d28c6.png";